import { useState } from "react";

function polarToCartesian(radius, angleInRadians) {
  const x = radius * Math.cos(angleInRadians);
  const y = radius * Math.sin(angleInRadians);
  return { x, y };
}

const emptyChartParams = { value: 0, color: "#e2e8f0", fontFamily: "var(--INTER)" };

const DonutChart = ({
  id = "",
  data,
  width,
  height,
  radius,
  thickness = radius / 2,
  fontSize = "16px",
  style = { pointerEvents: "all", fontFamily: "var(--INTER)", borderRadius: "50%" },
}) => {
  const [choosenJart, setChoosenJart] = useState(data[0]);
  const total = data?.reduce((sum, d) => sum + d.value, 0);

  let startAngle = 0;
  let endAngle = 0;
  const drawSectorChart = (item, i) => {
    const { value, color } = item;
    let offset = 0;
    if (value > 0) offset = 0;
    const percentage = total ? value / total : 1;
    endAngle = startAngle + percentage * 2 * Math.PI - offset;
    const innerRadius = radius - thickness;
    const outerStart = polarToCartesian(radius, startAngle);
    const outerEnd = polarToCartesian(radius, endAngle);
    const innerStart = polarToCartesian(innerRadius, startAngle);
    const innerEnd = polarToCartesian(innerRadius, endAngle);
    const largeArcFlag = percentage > 0.5 ? 1 : 0;
    const pathData = [
      `M ${outerStart.x} ${outerStart.y}`,
      `A ${radius} ${radius} 0 ${largeArcFlag} 1 ${outerEnd.x} ${outerEnd.y}`,
      `L ${innerEnd.x} ${innerEnd.y}`,
      `A ${innerRadius} ${innerRadius} 0 ${largeArcFlag} 0 ${innerStart.x} ${innerStart.y}`,
      `Z`,
    ].join(" ");

    startAngle = endAngle + offset;
    return (
      <path style={{ cursor: "pointer" }} onClick={() => setChoosenJart(item)} d={pathData} fill={color} key={i || 0} />
    );
  };

  const arcs = total
    ? data?.map(({ value, color }, i) => drawSectorChart({ value, color }, i))
    : drawSectorChart(emptyChartParams);

  const textX = 0;

  const textStyle = {
    fontSize: fontSize,
    fontFamily: "var(--INTER)",
    textAnchor: "middle",
    dominantBaseline: "central",
    fontWeight: 500,
    fill: "var(--headers)",
    width: "170px",
    textAlign: "center",
  };

  const countStyle = {
    fontWeight: 600,
    fill: "var(--accent)",
    fontSize: "40px",
    fontFamily: "var(--INTER)",
    textAnchor: "middle",
  };

  const sum = data.reduce((accumulator, currentItem) => {
    return accumulator + currentItem.value;
  }, 0);

  return (
    <svg xmlns="http://www.w3.org/2000/svg" id={id} width={width} height={height} style={style}>
      <circle cx={width / 2} cy={height / 2} r={height / 2} fill="white" />
      <g transform={`translate(${width / 2}, ${height / 2})`}>
        {arcs}
        <defs>
          <radialGradient id="circleGradient" cx="0" cy="0" r="100%" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor="#FFFFFF" />
            <stop offset="100%" stopColor="#E0E6E6" />
          </radialGradient>

          <filter id="shadow" x="-20%" y="-20%" width="140%" height="140%">
            <feDropShadow dx="0" dy="5" stdDeviation="3" floodColor="black" floodOpacity="0.4" />
          </filter>
        </defs>
        <circle filter="url(#shadow)" cx={0} cy={0} r={110} fill="url(#circleGradient)" />
        <text className="" x={textX} y={-50} style={textStyle}>
          Ложные
        </text>
        <text className="" x={textX} y={-30} style={textStyle}>
          срабатывания
        </text>
        <text x={textX} style={countStyle} y={25}>
          {sum}
        </text>
        <text x={textX} y={50} style={textStyle}>
          Всего за смену
        </text>
      </g>
    </svg>
  );
};

export default DonutChart;
